export enum JoinStatusEnum {
  Undefined = 0,
  Approved = 1,
  Pending = 2,
  Disapproved = 3,
}
